import { render } from "./management.cattle.io.user.vue?vue&type=template&id=363812e0"
import script from "./management.cattle.io.user.vue?vue&type=script&lang=js"
export * from "./management.cattle.io.user.vue?vue&type=script&lang=js"

import "./management.cattle.io.user.vue?vue&type=style&index=0&id=363812e0&lang=scss"

import exportComponent from "../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__